module.exports = __webpack_public_path__ + "img/botabib2_1.a4cda23e.gif";